import React from "react";
import Answer from "./Answer";

const Answers = ({ answers, handleClick, currentAnswer }) => {
  return (
    <>
      <Answer
        letter="a"
        answer={answers.answer_a}
        selected={currentAnswer === "a"}
        handleClick={handleClick}
      />
      <Answer
        letter="b"
        answer={answers.answer_b}
        selected={currentAnswer === "b"}
        handleClick={handleClick}
      />
      <Answer
        letter="c"
        answer={answers.answer_c}
        selected={currentAnswer === "c"}
        handleClick={handleClick}
      />

      {/* {answers.map((answer, index) => (
        <Answer letter="a" answer={answer.answer} handleClick={handleClick} />
      ))} */}
    </>
  );
};
export default Answers;
